import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { Benefits as Desc } from './desk'
import { Benefits as Mob } from './mob'

type Props = {
  images: TImages
}
export const Benefits: React.FC<Props> = ({ images }) => {
  const { isMobile } = useDimensions()
  return isMobile ? <Mob images={images} /> : <Desc images={images} />
}
